import { useState, useEffect, useMemo, useRef, useContext } from "react";
import { useSession } from "next-auth/react";
import {
  Text,
  Button,
  Center,
  Box,
  useColorModeValue,
} from "@chakra-ui/react";
import { addRemovePeopleToList, getIcebreaker, getContacts } from "controllers/list";
import { CopyToClipboard } from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import { MainContext } from "../../context/mainContext";
import { useMiscellaneousContext } from "context/miscellaneousContext";
import { textStyle } from "theme/names";


export const GetIcebreakerButton = ({ session, contacts, setContacts = undefined as any, data, row, value, columnRefresher }) => {

  // const [isLoading, setIsLoading] = useState<boolean>(!!row.isLoadingEmail);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [icebreaker, setIcebreaker] = useState(value?.length ? value : undefined);
  const mainContext = useContext(MainContext);
  const miscellaneousContext: any = useMiscellaneousContext();

  // console.log("render GetEmailButton isLoading: " + isLoading);

  return (
    <Box textAlign="left">
      {
        icebreaker ? icebreaker !== "failed to generate" ? (
        // false ? false ? (
          <CopyToClipboard
            text={icebreaker}
            onCopy={() => {
              toast.success("Icebreaker copied to clipboard");
            }}
          >
            <Text textStyle={textStyle["body.medium.light"]}
              noOfLines={1} wordBreak={"break-all"}
              mr="2"
              // fontSize="sm"
              // fontWeight="600"
              cursor="pointer"
              onClick={e => e.stopPropagation()}
            >
              {icebreaker}
            </Text>
          </CopyToClipboard>
        ) : (
          <Text textStyle={textStyle["body.medium.light"]}
            noOfLines={1} wordBreak={"break-all"}
            mr="2"
            // fontSize="sm"
            // fontWeight="600"
            cursor="auto"
          >
            {icebreaker}
          </Text>
        ) : (
          <Button
            size="sm"
            variant="secondary"
            // _hover={{
            //   background: useColorModeValue("gray.200", "whiteAlpha.200"),
            // }}
            isLoading={isLoading}
            onClick={async (e) => {
              e.stopPropagation();
              // console.log({ row });
              // console.log({ value });
              setIsLoading(true);
              row.isLoadingEmail = true;
              // row.emails = ["toto"];
              await getIcebreaker(
                session,
                [row.original],
                contacts,
                undefined,
                data,
                [setIcebreaker],
                mainContext,
                true,
                columnRefresher,
                miscellaneousContext,
              );
              setIsLoading(false);
              row.isLoadingEmail = false;
              // console.log("end");
            }}
          >
            Get Icebreaker
          </Button>
        )
      }
    </Box>
  );
}